import { PetCard } from "../../../../../components/ui/PetCard";
import {
  EmptySection
} from "./SectionPrimitives";



export function PetsSection({ pets }) {
  if (!pets.length) return <EmptySection>Nenhum pet encontrado.</EmptySection>;

  return (
    <div className="pt-3 pb-6 gap-3 flex flex-wrap" >
      {
        pets.map((pet,
          index) => (
          <article
            data-active={pet.active}
            className="min-w-[100px] flex gap-3 data-[active=false]:opacity-50 transition-opacity duration-300 hover:!opacity-100"
            key={pet.id || `${pet.name}-${index}`}
          >
            <PetCard.Root
              noAction
              size="small"
              direction="column"
              style={{
                maxWidth: "fit-content",
                minWidth: "initial",
              }}
            >
              <PetCard.Attributes full attributes={pet.card.attributes} show={["Nome"]} />
              <PetCard.Avatar url={pet.photo} attributes={pet.card.attributes} />
            </PetCard.Root>
            <PetCard.Root
              data-full
              noAction
              direction="row-reverse"
              size="small"
              title="Informações"
              style={{ minWidth: "400px", }}
            >
              <PetCard.Badges show={pet.card.badges} direction="column" />
              <PetCard.Attributes
                attributes={pet.card.attributes}
                show={[
                  "Raça",
                  "PetPeso",
                  "Castrado",
                  "Sexo",
                  "Nascimento",
                  "Idade",
                  "Pelagem",
                  "Status"
                ]}
              />
            </PetCard.Root>

          </article>
        ))
      }
    </div >
  );
}
